import { MCPServer, MCPTransport, MCPSharingMode } from '../../services/mcpApi';

/** Which screen the modal is showing. */
export type View =
  | { kind: 'list' }
  | { kind: 'details'; server: MCPServer }
  | { kind: 'form'; server?: MCPServer };

/** A single row in the custom-headers key/value editor. */
export interface HeaderRow {
  key: string;
  value: string;
}

/** Local state backing the add/edit form. OAuth is NOT a form choice — the
 * backend detects it from the server at save time. On edit of a detected-OAuth
 * server the client ID/secret are editable (secret is write-only). */
export interface FormState {
  name: string;
  description: string;
  transport: MCPTransport;
  url: string;
  headers: HeaderRow[];
  oauthClientId: string;
  oauthClientSecret: string;
  // Space/comma-separated OAuth scopes; blank = request everything the server advertises.
  oauthScopes: string;
  // shared = one credential set for everyone; individual = each user configures their own
  sharingMode: MCPSharingMode;
}

/** Pull a human-readable message out of an axios error, falling back to a default.
 * `detail` is either a plain string or a structured {code, message} object. */
export const extractErrorDetail = (error: any, fallback: string): string => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (typeof detail?.message === 'string') return detail.message;
  return fallback;
};

/** Machine-readable code from a structured error detail ({code, message}), if any. */
export const extractErrorCode = (error: any): string | null => {
  const code = error?.response?.data?.detail?.code;
  return typeof code === 'string' ? code : null;
};
